import { render, staticRenderFns } from "./CookieConsentPopup.vue?vue&type=template&id=39f98dbe&scoped=true"
import script from "./CookieConsentPopup.vue?vue&type=script&lang=js"
export * from "./CookieConsentPopup.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentPopup.vue?vue&type=style&index=0&id=39f98dbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f98dbe",
  null
  
)

export default component.exports